<template>
  <el-card style="margin-bottom: 50px">
    <div class="add-goods-container">
      <hm-step
        :scroll="true"
        :steps="steps"
        @scroll="windowScroll"
        :step="currentStep"
      ></hm-step>
      <el-scrollbar :style="{ height: scrollHeight + 'px' }">
        <div>
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="product-ruleForm"
          >
            <div id="base">1.基本信息</div>
            <el-form-item label="商品货号：">
              <div>
                <el-input
                  size="small"
                  clearable
                  class="mr10 ipt"
                  v-model.trim="ruleForm.goodsSn"
                  placeholder="不填系统将自动生成"
                ></el-input>
                <el-checkbox v-model="ruleForm.isMultCodes"
                  >一品多码</el-checkbox
                >
              </div>
              <div class="form-item-tip">
                用于商家内部管理使用，唯一编码，具体规则由商家自定义
              </div>
            </el-form-item>
            <el-form-item label="商品条码：" v-if="!ruleForm.isMultCodes">
              <el-input
                size="small"
                clearable
                class="mr10 ipt"
                v-model.trim="ruleForm.spuBarcode"
                placeholder="不填系统将自动生成"
              ></el-input>
              <div class="form-item-tip">
                输入标准商品条码，若一品多码，勾选一品多码后，在规格信息中维护其他条码
              </div>
            </el-form-item>
            <el-form-item label="商品名称：" prop="spuName">
              <el-input
                size="small"
                clearable
                class="mr10 ipt"
                v-model.trim="ruleForm.spuName"
                placeholder="例如：农夫山泉矿泉水550ml"
              ></el-input>
              <el-button type="text" @click="dialogVisible = true"
                >快速导入京东商品信息（限时免费）</el-button
              >
            </el-form-item>
            <el-form-item
              label="商品类目："
              class="is-required"
              prop="category"
            >
              <el-cascader
                v-model="ruleForm.categoryId"
                :show-message="isShowCategoryErr"
                :show-all-levels="false"
                size="small"
                ref="cascader"
                :props="categoryFunc"
                clearable
              ></el-cascader>
              <el-button
                class="btn"
                size="small"
                @click="toUrl('CategoryManagerment')"
                icon="hmicon icon-hao"
                >新建类目</el-button
              >
              <div class="form-item-tip">商品类目用于店铺内部经营管理</div>
            </el-form-item>
            <el-form-item label="商品品牌：" prop="brandId">
              <hm-brand-selector
                v-model="ruleForm.brandId"
                :brand-name="selectedBrandName"
                @change="handleBrandChange"
                @add="toUrl('AddBrand')"
              ></hm-brand-selector>
            </el-form-item>
            <el-form-item
              label="属性设置："
              class="is-required"
              prop="attribute"
            >
              <el-cascader
                v-model="ruleForm.spuAttributeList"
                :show-message="isShowAttributeErr"
                :show-all-levels="false"
                size="small"
                :props="attributeFunc"
                clearable
              ></el-cascader>
              <el-button
                class="btn"
                size="small"
                @click="toUrl('AddAttribute')"
                icon="hmicon icon-hao"
                >添加属性值</el-button
              >
              <div class="form-item-tip">
                辅助属性即商品的标签管理，便于商家做产品规范化管理
              </div>
            </el-form-item>
            <el-form-item label="商品净重：">
              <el-input
                v-model.trim="ruleForm.netWeight"
                @input="filterGt0OrFixed2('netWeight')"
                class="mr10"
                size="small"
                type="number"
                style="width: 80px"
              ></el-input>
              <el-select
                style="width: 100px"
                size="small"
                class="auto-width-select"
                v-model="ruleForm.weightUnit"
                placeholder="请选择商品净重"
              >
                <el-option label="克" value="g"></el-option>
                <el-option label="千克" value="kg"></el-option>
              </el-select>
              <div class="form-item-tip">
                商品重量应用到计算与重量相关的配送方式计价
              </div>
            </el-form-item>
            <el-form-item label="商品毛重：">
              <el-input
                v-model.trim="ruleForm.grossWeight"
                @input="filterGt0OrFixed2('grossWeight')"
                class="mr10"
                size="small"
                type="number"
                style="width: 80px"
              ></el-input>
              <el-select
                style="width: 100px"
                size="small"
                class="auto-width-select"
                v-model="ruleForm.weightUnit"
                placeholder="请选择商品净重"
              >
                <el-option label="克" value="g"></el-option>
                <el-option label="千克" value="kg"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="建议零售价：" prop="recommendedRetailPrice">
              <el-input
                size="small"
                clearable
                class="mr10 ipt"
                @input="filterGt0OrFixed2('recommendedRetailPrice')"
                v-model.trim="ruleForm.recommendedRetailPrice"
                placeholder="请填写商品建议零售价"
              ></el-input>
              <div class="form-item-tip">
                商品库中维护商品建议零售价，实际销售价格根据不同渠道维护
              </div>
            </el-form-item>
            <el-form-item label="保底价：">
              <el-input
                size="small"
                clearable
                class="mr10 ipt"
                @input="filterGt0OrFixed2('basePrice')"
                v-model.trim="ruleForm.basePrice"
                placeholder="请填写商品保底价"
              ></el-input>
              <div class="form-item-tip">
                商品库中设置的商品保底价，用于活动价格比较，活动价低于此价格时进行提示警告
              </div>
            </el-form-item>
            <el-form-item label="发货商：">
              <el-select
                clearable
                size="small"
                class="auto-width-select"
                filterable
                v-model="ruleForm.supplierId"
                placeholder="请选择发货商"
              >
                <el-option label="自营" value=""></el-option>
                <el-option
                  v-for="(item, i) in supplierInfoList"
                  :key="i"
                  :label="item.supplierName"
                  :value="item.supplierId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="主图：">
              <el-upload
                class="upload flex"
                ref="eluploadMainPic"
                :limit="1"
                drag
                :data="{ fileDir: 'mall' }"
                :headers="{ 'X-Access-Token': $token }"
                :action="$uploadUrl"
                :onSuccess="uploadMainPicSucc"
                :beforeUpload="beforeUpload"
                :onProgress="uploading"
                :show-file-list="uploadShow"
                v-if="!ruleForm.spuMainPic"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将图片拖到此处，或
                  <em>点击上传</em>
                </div>
                <div class="el-upload__tip" slot="tip">
                  <div class="ml10">
                    上传图片注意：
                    <div>
                      1.主图仅可设置一张
                    </div>
                    <div>
                      2.图片尺寸建议750x750
                    </div>
                  </div>
                </div>
              </el-upload>
              <div class="priview" v-if="ruleForm.spuMainPic">
                <img :src="ruleForm.spuMainPic" alt="主图" />
                <div class="opreat-wrapper flex item-center flex-center">
                  <el-button type="text" @click="handleRemove">删除</el-button>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="轮播组图：" prop="listDetail">
              <el-upload
                v-show="spuSlideShowPicList.length < 6"
                class="upload flex"
                ref="elupload"
                :limit="6"
                drag
                multiple
                :data="{ fileDir: 'mall' }"
                :headers="{ 'X-Access-Token': $token }"
                :action="$uploadUrl"
                :on-remove="handleRemoves"
                :onError="uploadError"
                :onSuccess="cropUploadSuccesss"
                :beforeUpload="beforeAvatarUpload"
                :onProgress="uploading"
                :show-file-list="uploadShow"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将图片/视频拖到此处，或
                  <em>点击上传</em>
                </div>
                <div class="el-upload__tip" slot="tip">
                  <div class="ml10">
                    上传图片/视频注意：
                    <div>
                      1.图片尺寸建议750x750
                    </div>
                    <div>
                      2.图片格式：png、jpg、bmp，视频格式：mp4,且不得超过10M
                    </div>
                    <div>
                      3.轮播图可设置6张,视频可设置1个
                    </div>
                    <div>
                      4.轮播图可以拖拽调整顺序
                    </div>
                  </div>
                </div>
              </el-upload>
              <!-- <el-button
                type="primary"
                size="small"
                v-show="spuSlideShowPicList.length < 6"
                @click="toggleShowDetail"
                >上传</el-button
              >
              <span class="form-tip"
                >（列表详情图可设置6张，图片尺寸建议750x750）</span
              > -->
              <draggable :list="spuSlideShowPicList" class="flex flex-wrap">
                <div
                  class="priview mr10"
                  v-show="v"
                  v-for="(v, i) in spuSlideShowPicList"
                  :key="i"
                >
                  <img
                    :src="v"
                    v-if="v.indexOf('.mp4') === -1 && v.indexOf('.MP4') === -1"
                    alt="列表详情图"
                  />
                  <video class="video" controls :src="v" v-else></video>
                  <div class="opreat-wrapper flex item-center flex-center">
                    <el-button type="text" @click="setFirst(i)"
                      >设为第一张图</el-button
                    >
                    <el-button
                      type="text"
                      v-if="
                        v.indexOf('.mp4') === -1 && v.indexOf('.MP4') === -1
                      "
                      @click="setMainPic(i)"
                      >设为主图</el-button
                    >
                    <el-button type="text" @click="handleRemoveListDetail(i)"
                      >删除</el-button
                    >
                  </div>
                </div>
              </draggable>
            </el-form-item>
            <el-form-item label="图文详情：">
              <hm-rich-editor
                v-model="ruleForm.spuDetails"
                :html="ruleForm.spuDetails"
              />
            </el-form-item>
            <div id="specification" v-if="ruleForm.isMultCodes">2.规格信息</div>
            <el-form-item
              label="规格添加"
              class="is-required"
              v-show="ruleForm.isMultCodes"
              prop="skuModelList"
            >
              <ul class="specification-list">
                <li
                  class="flex item-center"
                  v-for="(v, i) in ruleForm.specificationList"
                  :key="i"
                >
                  <el-select
                    size="small"
                    v-model="v.specId"
                    class="mr10"
                    placeholder="请选择商品规格"
                    filterable
                    @change="switchSpecification(v, i)"
                  >
                    <el-option
                      :label="item.specName"
                      :value="item.specId"
                      v-for="(item, index) in specList"
                      :key="index"
                    ></el-option>
                  </el-select>
                  <div class="spec-value-select mr10 flex item-center">
                    <el-tag
                      size="small"
                      closable
                      v-for="(tag, idx) in v.attr"
                      :key="tag.valueId"
                      @close="removeAttr(v, i, idx)"
                      class="mr5"
                    >{{ tag.specValue }}</el-tag>
                    <el-button
                      style="margin-left:10px"
                      size="mini"
                      :disabled="!v.specId || !v.specModels || !v.specModels.length"
                      @click="openSpecValueDialog(v, i)"
                    >选择规格值</el-button>
                  </div>
                  <el-button
                    type="primary"
                    size="small"
                    circle
                    :disabled="ruleForm.specificationList.length > 2"
                    @click="addSpecification"
                    class="hmicon icon-hao pointer"
                    v-show="i === 0"
                  ></el-button>
                  <el-button
                    size="small"
                    circle
                    plain
                    @click="deleteSpecification(v, i)"
                    type="primary"
                    class="hmicon hmicon icon-jianhao"
                    v-show="i !== 0"
                  ></el-button>
                  <el-button
                    size="small"
                    :disabled="!v.specId"
                    @click="addSpecModelsNew(v,i)"
                    class="hmicon icon-hao pointer"
                    v-if="v.specId"
                  >添加规格值</el-button>
                </li>
              </ul>
              <div class="table" v-show="ruleForm.skuModelList.length">
                <div class="table-control flex flex-end">
                  <el-input
                    class="mr10"
                    v-model.trim="recommendedRetailPrice"
                    @input="filterGt0OrFixed2('recommendedRetailPrice')"
                    size="small"
                    style="100px"
                    placeholder="输入零售价"
                  ></el-input>
                  <div class="pointer" @click="batchSetting">
                    <span class="delete-icon hmicon icon-xitong"></span>
                    批量设置
                  </div>
                </div>
                <div class="table-body">
                  <div class="table-row flex">
                    <div
                      class="flex-1 text-center"
                      v-for="(v, i) in ruleForm.specificationList"
                      :key="i"
                    >
                      {{ v.specName }}
                    </div>
                    <div class="flex-1 text-center">规格条码
                      <el-tag
                        size="mini"
                        effect="plain"
                        color="#FFEEF6"
                        @click="showBarcode"
                        >
                        <span class="hmicon icon-shuru hmicon-shuru"></span>
                          自动生成
                        </el-tag
                      >
                    </div>
                    <div class="flex-1 text-center">建议零售价</div>
                    <!-- <div class="flex-1 text-center">规格图片</div> -->
                  </div>
                  <div
                    class="table-row flex item-center"
                    v-for="(v, i) in ruleForm.skuModelList"
                    :key="i"
                  >
                    <div
                      class="flex-1 text-center"
                      v-for="(item, index) in v.specValueList"
                      :key="index"
                    >
                      {{ item.specValue }}
                    </div>
                    <div class="flex-1 flex flex-center">
                      <el-input
                        size="small"
                        v-model.trim="v.specBarcode"
                      ></el-input>
                    </div>
                    <div class="flex-1 flex flex-center">
                      <el-input
                        style="width: 100px"
                        size="small"
                        @input="filterGt0OrFixedRecommendedRetailPrice(i)"
                        v-model.trim="v.recommendedRetailPrice"
                      ></el-input>
                    </div>
                    <!-- <div class="flex-1 flex flex-center">
                      <div class="flex upload-upload-btn" @click="addSkuPic(v, 'skuPic')">
                        <div
                          class="btn flex flex-column flex-center open-file"
                          v-if="!v.skuPic"
                        >
                          <div class="add-wrapper">
                            <span class="hmicon icon-hao pointer"></span>
                          </div>
                          <span>添加图片</span>
                        </div>
                        <div v-if="v.skuPic" class="mr10 flex item-end">
                          <img class="logo" :src="v.skuPic" alt="logo" />
                        </div>
                      </div>
                    </div> -->
                  </div>
                </div>
              </div>
            </el-form-item>
            <div id="way">{{ steps.length === 2 ? 2 : 3 }}销售渠道</div>
            <el-form-item label="销售渠道：">
              <el-select
                clearable
                multiple
                size="small"
                v-model="ruleForm.spuPlatFormList"
                placeholder="请选择销售渠道"
              >
                <el-option
                  :label="v.platformName"
                  :value="v.platformId"
                  v-for="(v, i) in salesChannels"
                  :key="i"
                ></el-option>
              </el-select>
              <div class="form-item-tip">
                选择渠道后，商品信息会同步到对应渠道
              </div>
            </el-form-item>
            <el-form-item label="销售状态：">
              <el-switch
                v-model="ruleForm.salesState"
                active-text="可售"
                inactive-text="停售"
                active-color="#13ce66"
                active-value="open"
                inactive-value="close"
              ></el-switch>
              <div class="form-item-tip">
                设置销售状态，直接影响渠道内商品是否可售，禁售状态下所有渠道商品不可销售
              </div>
            </el-form-item>
            <div class="flex flex-center">
              <el-button
                type="primary"
                size="small"
                @click="submitRuleForm('ruleForm')"
                >提交</el-button
              >
              <el-button size="small" @click="$router.back(-1)">返回</el-button>
            </div>
          </el-form>
        </div>
      </el-scrollbar>
    </div>
    <el-dialog
      title="导入商品信息"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="1000px"
    >
    <div class="mb10">
      <el-image
        src="https://imgcdn.hemiao100.com/ThemePictures/%E7%BB%84%2091%402x.png"
      >
      </el-image>
    </div>
      <el-form label-width="80px">
        <el-form-item label="商品链接">
          <el-input placeholder="请输入商品链接" style="width:380px" size="small" type="text" v-model.trim="url"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="importOutSource" size="small" type="primary"
          >提取图片</el-button
        >
        <el-button @click="dialogVisible = false" size="small">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="自动生成规格条码"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleBarcodeLength"
      width="600px"
    >
      <el-form label-width="120px">
        <el-form-item label="规格条码位数">
          <el-input
            class="mr10"
            v-model.trim="barcodeLength"                    
            size="small"
            style="100px;"
            @blur="numberBlur"
            placeholder="请输入规格条码8-16位数"
          ></el-input>
          <div class="barcodeTips">规格条码限制8-16位数,规格条码为空会自动生成随机数,已有的规格条码不受影响</div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="batchSettingSpec" size="small" type="primary"
          >确认</el-button
        >
        <el-button @click="dialogVisibleBarcodeLength = false" size="small">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="添加规格值"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleSpecModels"
      width="600px"
    >
      <el-form label-width="120px" :rules="rulesAddSpec" :model="formSpec" ref="formSpec">
        <el-form-item label="规格">
          <el-select
            size="small"
            v-model="formSpec.specId"
            class="mr10"
            disabled
            placeholder="请选择商品规格"
            @change="switchSpecification(v, i)"
          >
            <el-option
              :label="item.specName"
              :value="item.specId"
              v-for="(item, index) in specList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="规格值" prop="specValue">
          <el-input
            class="mr10"
            v-model.trim="formSpec.specValue"                    
            size="small"
            style="100px;"
            @input="filterGt()"
            placeholder="请输入规格值数"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="addSpecSubmit('formSpec')" size="small" type="primary"
          >确认</el-button
        >
        <el-button @click="dialogVisibleSpecModels = false" size="small">取消</el-button>
      </span>
    </el-dialog>
    <hm-spec-value-selector
      :visible.sync="dialogVisibleSpecValue"
      :source-list="currentSpecValueSource"
      :selected-list="currentSpecValueSelected"
      @confirm="confirmSpecValue"
    ></hm-spec-value-selector>
  </el-card>
</template>

<script>
import { getLoginUser } from "@/utils/auth";
import myUpload from "vue-image-crop-upload";
import HmRichEditor from "@/components/HmRichEditor";
import HmStep from "@/components/HmStep";
import { arrayUnique2 } from "@/utils/utils";
import { mapGetters } from "vuex";
import draggable from "vuedraggable";
import HmBrandSelector from "@/components/HmBrandSelector";
import HmSpecValueSelector from "@/components/HmSpecValueSelector";

export default {
  components: { myUpload, HmRichEditor, HmStep, draggable, HmBrandSelector, HmSpecValueSelector },
  data() {
    const patternCategoryFunc = function(rule, val, callback) {
      if (!this.ruleForm.categoryId.length) {
        this.isShowCategoryErr = true;
        return callback(new Error("请选择类目"));
      }
      this.isShowCategoryErr = false;
      callback();
    }.bind(this);
    const patternFunc = function(rule, val, callback) {
      this.ruleForm.skuModelList.map(v => {
        // eslint-disable-next-line no-unused-vars
        for (let key in v) {
          if (!v.specBarcode || !v.recommendedRetailPrice) {
            return callback(new Error("请选择规格"));
          }
        }
        callback();
      });
      callback();
    }.bind(this);
    const patternAttributeFunc = function(rule, val, callback) {
      if (!this.ruleForm.spuAttributeList.length) {
        this.isShowAttributeErr = true;
        return callback(new Error("请选择属性"));
      }
      this.isShowAttributeErr = false;
      callback();
    }.bind(this);
    // typeId 父级Id
    // specId 子级Id
    return {
      errorMsg:"",
      isRepeat: false,
      specBarcodeList:[],
      uploadShow: true,
      isSaving: false,
      supplierInfoList: [],
      url: "",
      currentSpec: null,
      uploadType: "",
      dialogVisible: false,
      specification: "",
      currentStep: 1,
      allAttr: [],
      steps: [
        {
          name: "添加基本信息",
          id: "base"
        },
        {
          name: "销售渠道发布",
          id: "way"
        }
      ],
      isShowCategoryErr: true,
      isShowAttributeErr: true,
      scrollHeight: 0,
      showDetail: false,
      show: false,
      isMininum: true,
      applyCount: 0,
      activityDate: "",
      inputValue: "",
      activeTab: 0,
      type: 0,
      spuSlideShowPicList: [],
      storeId: "",
      startDate: "",
      validDate: "",
      editorOption: {},
      selectedIndex: "",
      chargeType: "",
      barcodeLength: "",
      dialogVisibleBarcodeLength: false,
      categoryFunc: {
        checkStrictly: true,
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryGoodsCategoryTree", {
                categoryLevel: 1
              })
              .then(res => {
                res.result.forEach(v => {
                  v.value = v.categoryId;
                  v.label = v.categoryName;
                });
                resolve(res.result);
              });
          } else {
            this.$store
              .dispatch("queryGoodsCategoryTree", {
                categoryLevel: level + 1,
                parentCategoryId: data.categoryId
              })
              .then(res => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach(v => {
                    v.value = v.categoryId;
                    v.label = v.categoryName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      },
      attributeFunc: {
        lazy: true,
        multiple: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store.dispatch("queryAttrListByAddGoods").then(res => {
              res.result.forEach(v => {
                v.value = v.valueId;
                v.label = v.attributeValue;
              });
              resolve(res.result);
            });
          } else {
            let params = {};
            if (level === 1) {
              params = {
                typeId: data.valueId
              };
            } else {
              params = {
                attributeId: data.valueId
              };
            }
            this.$store
              .dispatch("queryAttrListByAddGoods", params)
              .then(res => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach(v => {
                    v.value = v.valueId;
                    v.label = v.attributeValue;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      },
      recommendedRetailPrice: "",
      ruleForm: {
        goodsSn: "",
        isMultCodes: false,
        spuBarcode: "",
        spuName: "",
        categoryId: [],
        skuModelList: [],
        brandId: "",
        spuAttributeList: [],
        netWeight: "",
        grossWeight: "",
        weightUnit: "g",
        recommendedRetailPrice: "",
        basePrice: "",
        supplierId: "",
        spuMainPic: "",
        spuDetails: "",
        specificationList: [
          {
            specName: "",
            specId: "",
            specModels: []
          }
        ],
        spuPlatFormList: [],
        salesState: "open"
      },
      rules: {
        spuName: [
          {
            required: true,
            message: "请输入商品名称",
            trigger: "blur"
          },
          {
            required: true,
            min: 2,
            max: 100,
            message: "名称应大于2小于100个字",
            trigger: "blur"
          }
        ],
        category: {
          validator: patternCategoryFunc,
          trigger: "change"
        },
        brandId: {
          required: true,
          message: "请选择商品品牌",
          trigger: "change"
        },
        attribute: {
          validator: patternAttributeFunc,
          trigger: "blur"
        },
        recommendedRetailPrice: {
          required: true,
          message: "请输入建议零售价",
          trigger: "blur"
        },
        skuModelList: {
          validator: patternFunc,
          trigger: "blur"
        }
      },
      dialogVisibleSpecModels: false,
      formSpec: {
        specId: "",
        specValue: "",
      },
      rulesAddSpec:{
        specValue: {
          required: true,
          message: "请输入规格值数",
          trigger: "blur"
        },
      },
      currentSpecIndex: -1,
      dialogVisibleSpecValue: false,
      currentSpecValueSource: [],
      currentSpecValueSelected: [],
      currentSpecValueRow: null,
      currentSpecValueIndex: -1,
      selectedBrandName: "",
    };
  },
  computed: {
    ...mapGetters([
      "specList",
      "allBrandList",
      "attrList",
      "supplierList",
      "salesChannels"
    ]),
  },
  watch: {
    "ruleForm.isMultCodes": {
      handler(val) {
        if (val) {
          this.steps = [
            {
              name: "添加基本信息",
              id: "base"
            },
            {
              name: "添加规格信息",
              id: "specification"
            },
            {
              name: "销售渠道发布",
              id: "way"
            }
          ];
        } else {
          this.steps = [
            {
              name: "添加基本信息",
              id: "base"
            },
            {
              name: "销售渠道发布",
              id: "way"
            }
          ];
        }
      },
      deep: true
    }
  },
  created() {
    this.$store.dispatch("querySpecListByAddGoods");
    this.$store.dispatch("querySalesChannels");
    // this.$store.dispatch("querySupplierList");
  },
  mounted() {
    this.querySupplierInfoComboBox();
    this.$nextTick(() => {
      window.addEventListener("scroll", this.handleScroll, true);
      window.addEventListener("resize", this.handleResize, true);
      this.calcHeight();
    });
  },
  destroyed: function() {
    window.removeEventListener("scroll", this.handleScroll); //  离开页面清除（移除）滚轮滚动事件
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    // 上传错误
    uploadError() {
      this.$message({
        message: "上传失败，请重试!",
        type: "warning"
      });
      this.isSaving = false;
    },
    // 正在上传
    uploading() {
      this.isSaving = true;
      this.uploadShow = true;
    },
    async querySupplierInfoComboBox() {
      const { result } = await this.$store.dispatch(
        "querySupplierInfoComboBox"
      );
      this.supplierInfoList = result;
    },
    async importOutSource() {
      // eslint-disable-next-line no-useless-escape
      const pattern = /^(ht|f)tp(s?)\:\/\/[0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*(:(0-9)*)*(\/?)([a-zA-Z0-9\-\.\?\,\'\/\\\+&amp;%\$#_]*)?/;
      if (!pattern.test(this.url)) {
        this.$message({
          type: "warning",
          message: "请输入正确的url！"
        });
      } else {
        const { result } = await this.$store.dispatch("querySpiderImg", {
          url: encodeURIComponent(this.url)
        });
        // this.ruleForm.spuName = result.name || "";
        this.ruleForm.spuMainPic = result.img || "";
        this.spuSlideShowPicList = result.imgList || [];
        if (result.detail) {
          let str = "";
          result.detail.map(v => {
            str += `<img src="${v}" />`;
          });
          this.ruleForm.spuDetails = str;
        }
        this.dialogVisible = false;
        this.url = "";
        this.$message({
          type: "success",
          message: "导入成功"
        });
      }
    },
    handleResize() {
      this.calcHeight();
    },
    calcHeight() {
      setTimeout(() => {
        const headerHeight = document.querySelector(".navbar")
          ? document.querySelector(".navbar").getBoundingClientRect().y
          : 0;
        const tagHeight = document.querySelector(".tags-view-container")
          ? document
              .querySelector(".tags-view-container")
              .getBoundingClientRect().y
          : 0;
        const stepsHeight = document.querySelector(".step-wrapper")
          ? document.querySelector(".step-wrapper").getBoundingClientRect().y
          : 0;
        const footerHeight = document.querySelector(".el-footer")
          ? document.querySelector(".el-footer").getBoundingClientRect().height
          : 0;
        this.scrollHeight =
          window.innerHeight -
          headerHeight -
          tagHeight -
          stepsHeight -
          footerHeight -
          80;
      }, 0);
    },
    handleScroll(e) {
      this.steps.map((v, i) => {
        const ele = document.getElementById(v.id);
        if (ele) {
          const offsetTop = ele.offsetTop;
          if (e.target.scrollTop + 360 > offsetTop) {
            this.currentStep = i + 1;
          } else if (e.target.scrollTop < 100) {
            this.currentStep = 1;
          } else {
            this.currentStep = i - 1;
          }
        }
      });
    },
    windowScroll(i) {
      this.$nextTick(() => {
        document.getElementById(this.steps[i].id).scrollIntoView();
        this.currentStep = i + 1;
      });
    },
    addSpecification() {
      this.ruleForm.specificationList.push({
        specName: "",
        specId: "",
        specModels: []
      });
    },
    deleteSpecification(v, i) {
      this.ruleForm.skuModelList.forEach(o => {
        o.specValueList.forEach((p, index) => {
          v.attr.map(q => {
            if (p.specId === q.specId) {
              o.specValueList.splice(index, 1);
            }
          });
        });
      });
      this.ruleForm.specificationList.splice(i, 1);
    },
    batchSetting() {
      this.ruleForm.skuModelList.forEach(v => {
        v.recommendedRetailPrice = this.recommendedRetailPrice;
      });
    },
    setAttrList(v, index) {
      let len = this.ruleForm.specificationList.length;
      this.ruleForm.skuModelList = [];
      let resultLen = 1;
      this.ruleForm.specificationList.map(o => {
        resultLen = resultLen * o.attr.length;
      });
      if (len === 1) {
        for (let i = 0; i < resultLen; i++) {
          let specValueList = [];
          specValueList[index] = v.attr[i];
          this.ruleForm.skuModelList.push({
            specValueList,
            specBarcode: "",
            recommendedRetailPrice: ""
          });
        }
      } else if (len === 2) {
        let arr = [];
        this.ruleForm.specificationList[0].attr.map(o => {
          this.ruleForm.specificationList[1].attr.map(p => {
            let arr2 = [];
            arr2.push(o, p);
            arr.push(arr2);
          });
        });
        for (let i = 0; i < resultLen; i++) {
          this.ruleForm.skuModelList.push({
            specValueList: arr[i],
            specBarcode: "",
            recommendedRetailPrice: ""
          });
        }
      } else if (len === 3) {
        let arr = [];
        this.ruleForm.specificationList[0].attr.map(o => {
          this.ruleForm.specificationList[1].attr.map(p => {
            this.ruleForm.specificationList[2].attr.map(q => {
              let arr2 = [];
              arr2.push(o, p, q);
              arr.push(arr2);
            });
          });
        });
        for (let i = 0; i < resultLen; i++) {
          this.ruleForm.skuModelList.push({
            specValueList: arr[i],
            specBarcode: "",
            recommendedRetailPrice: ""
          });
        }
      }
    },
    switchSpecification(v, i) {
      const currentRow = this.specList.find(o => o.specId === v.specId);
      this.selectedIndex = i;
      v.attr = [];
      if (currentRow) {
        // 规格值原始大数据改为非响应式，避免 Vue 递归劫持造成初始化卡顿
        v._rawSpecModels = Object.freeze((currentRow.specModels || []).slice());
        v.specModels = v._rawSpecModels.slice(0, 200);
        v.specName = currentRow.specName;
      }
    },
    addSkuPic(v, type) {
      this.currentSpec = v;
      this.uploadType = type;
      this.show = true;
    },
    openSpecValueDialog(v, i) {
      this.currentSpecValueRow = v;
      this.currentSpecValueIndex = i;
      const source = v._rawSpecModels || v.specModels || [];
      this.currentSpecValueSource = source;
      this.currentSpecValueSelected = v.attr || [];
      this.dialogVisibleSpecValue = true;
    },
    confirmSpecValue(result) {
      const v = this.currentSpecValueRow;
      v.attr = result;
      this.setAttrList(v, this.currentSpecValueIndex);
    },
    removeAttr(v, i, idx) {
      v.attr.splice(idx, 1);
      this.setAttrList(v, i);
    },
    handleBrandChange(row) {
      if (row) {
        this.ruleForm.brandId = row.brandId;
        this.selectedBrandName = row.brandName;
      } else {
        this.ruleForm.brandId = "";
        this.selectedBrandName = "";
      }
    },
    toUrl(url) {
      let routeUrl = this.$router.resolve({
        name: url
      });
      window.open(routeUrl.href, "_blank");
    },
    filterGt0OrFixed2(prop) {
      // this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (this.ruleForm[prop].indexOf(".") < 0 && this.ruleForm[prop] != "") {
        //首位是0的话去掉
        this.ruleForm[prop] = parseFloat(this.ruleForm[prop]);
      }
    },
    filterGt0OrFixedRecommendedRetailPrice(i) {
      // this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm.skuModelList[i].recommendedRetailPrice = this.ruleForm.skuModelList[i].recommendedRetailPrice.replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm.skuModelList[i].recommendedRetailPrice = this.ruleForm.skuModelList[i].recommendedRetailPrice.replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm.skuModelList[i].recommendedRetailPrice = this.ruleForm.skuModelList[i].recommendedRetailPrice
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm.skuModelList[i].recommendedRetailPrice = this.ruleForm.skuModelList[i].recommendedRetailPrice.replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (this.ruleForm.skuModelList[i].recommendedRetailPrice.indexOf(".") < 0 && this.ruleForm.skuModelList[i].recommendedRetailPrice != "") {
        //首位是0的话去掉
        this.ruleForm.skuModelList[i].recommendedRetailPrice = parseFloat(this.ruleForm.skuModelList[i].recommendedRetailPrice);
      }
    },
    toggleShow() {
      this.show = !this.show;
    },
    toggleShowDetail() {
      this.showDetail = !this.showDetail;
    },
    cropSuccess() {},
    /**
     * upload success
     *
     * [param] jsonData   服务器返回数据，已进行json转码
     * [param] field
     */
    cropUploadSuccesss(jsonData) {
      if (jsonData.code === 0) {
        this.spuSlideShowPicList.push(jsonData.result);
        this.uploadShow = false;
      }
    },
    submitRuleForm(formName){
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.addSpuCheckRepeatSpecBarcode().then(res =>{
            if(!this.isRepeat){
              this.submitForm(formName);
            }
          })
        }
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.ruleForm));
          params.categoryId = params.categoryId.length
            ? params.categoryId[params.categoryId.length - 1]
            : "";
          delete params.specificationList;
          params = Object.assign(params, {
            spuSlideShowPicList: this.spuSlideShowPicList,
            skuModelList: this.ruleForm.skuModelList
          });
          this.$store.dispatch("addGoods", params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.$router.back(-1);
            }
          });
        } else {
          return false;
        }
      });
    },
    async addSpuCheckRepeatSpecBarcode(){
      this.errorMsg = "";
      this.specBarcodeList = [];
      if(this.ruleForm.skuModelList.length>0){
        let skuModelListArrayUnique2;
        skuModelListArrayUnique2 = arrayUnique2(this.ruleForm.skuModelList, "specBarcode");
        if(skuModelListArrayUnique2.length < this.ruleForm.skuModelList.length){
          this.$message({
            message: "规格条码请勿重复!",
            type: "warning"
          });
          this.isRepeat = true;
          return false;
        }
        this.ruleForm.skuModelList.forEach(v=>{
          this.specBarcodeList.push({
           specBarcode:v.specBarcode
          })
        })      
        const { result } = await this.$store.dispatch("addSpuCheckRepeatSpecBarcode", {
          specBarcodeList: this.specBarcodeList,
        })
        if(result){
          this.isRepeat = false;
          result.specBarcodeList.forEach(v =>{
            if(v.checkState==='exist'){
              this.errorMsg = this.errorMsg + "规格条码(" + (v.specBarcode) + ")与数据库条码重复,";
              this.isRepeat = true;
            }
          })
          if(this.isRepeat){
            this.$message({
              message: this.errorMsg,
              type: "warning"
            });
          }
        }
      }
    },
    handleRemoves() {},
    // 移除上传文件
    handleRemove() {
      this.ruleForm.spuMainPic = "";
      this.$refs.eluploadMainPic.clearFiles();
    },
    // 上传前对文件的大小的判断
    beforeAvatarUpload(file) {
      const isUploadVideo =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "mp4";
      if (
        this.spuSlideShowPicList.find(
          v => v.indexOf(".mp4") > -1 || v.indexOf(".MP4") > -1
        ) &&
        isUploadVideo
      ) {
        this.$message({
          message: "仅支持上传一个视频",
          type: "warning"
        });
        return false;
      }
      const extension =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "jpg";
      const extension2 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
        "jpeg";
      const extension3 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "png";
      const extension4 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "bmp";
      // file.size单位为b，除以1024得到kb
      // const limitSize = file.size / 1024 <= 100;
      if (
        !extension &&
        !extension2 &&
        !extension3 &&
        !extension4 &&
        !isUploadVideo
      ) {
        this.$message({
          message: "上传模板只能是 jpg、jpeg、png、bmp、mp4格式!",
          type: "warning"
        });
      }
      // if (!limitSize) {
      //   this.$message({
      //     message: "上传模板大小不能超过 100k!",
      //     type: "warning"
      //   });
      // }
      let isSize = true;
      if (!isUploadVideo) {
        isSize = new Promise((resolve, reject) => {
          // let width = 750;
          // let height = 750;
          let _URL = window.URL || window.webkitURL;
          let img = new Image();
          // img.onload = function() {
          //   let valid = img.width >= width && img.height >= height;
          //   valid ? resolve() : reject();
          // };
          img.src = _URL.createObjectURL(file);
          resolve();
        }).then(
          () => {
            return file;
          },
          () => {
            this.$message({
              message: "图片最低像素为（宽*高）：750*750",
              type: "warning"
            });
            return Promise.reject();
          }
        );
      } else {
        const limitSize = file.size / 1024 / 1024 <= 10;
        if (!limitSize) {
          this.$message({
            message: "上传视频大小不能超过10M!",
            type: "warning"
          });
          return false;
        }
      }
      return (
        (extension ||
          extension2 ||
          extension3 ||
          extension4 ||
          isUploadVideo) &&
        isSize
      );
    },
    handleRemoveListDetail(file) {
      if (typeof file === "number") {
        this.spuSlideShowPicList.splice(file, 1);
      } else {
        const index = this.spuSlideShowPicList.findIndex(
          v => v === file.response.result
        );
        this.spuSlideShowPicList.splice(index, 1);
      }
    },
    uploadListDetailError() {
      this.$message({
        message: "上传失败，请重试!",
        type: "warning"
      });
    },
    uploadMainPicSucc(jsonData) {
      if (jsonData.code === 0) {
        this.ruleForm.spuMainPic = jsonData.result;
        this.spuSlideShowPicList.unshift(jsonData.result);
        this.uploadShow = false;
      }
    },
    beforeUpload(file) {
      const extension =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
          "jpg" ||
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "gif";
      const extension2 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
        "jpeg";
      const extension3 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "png";
      const extension4 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "bmp";
      // file.size单位为b，除以1024得到kb
      const limitSize = file.size / 1024 <= 1020;
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: "上传模板只能是 jpg、jpeg、png、bmp格式!",
          type: "warning"
        });
      }
      if (!limitSize) {
        this.$message({
          message: "上传模板大小不能超过 1M!",
          type: "warning"
        });
      }
      return (extension || extension2 || extension3 || extension4) && limitSize;
    },
    uploadListDetailSuccess(response) {
      this.spuSlideShowPicList.push(response.result);
      this.$message({
        type: "success",
        message: "上传成功！"
      });
    },
    setFirst(i) {
      let tmp = this.spuSlideShowPicList[0];
      this.spuSlideShowPicList[0] = this.spuSlideShowPicList[i];
      this.spuSlideShowPicList[i] = tmp;
      this.$forceUpdate();
    },
    setMainPic(i) {
      this.ruleForm.spuMainPic = this.spuSlideShowPicList[i];
    },
    numberBlur(){
      let msg;
      if (this.barcodeLength >=8 && this.barcodeLength <=16 && (/(^[1-9]\d*$)/.test(this.barcodeLength))) {
        console.log("this.barcodeLength:",this.barcodeLength);
      }else{
        msg = "请输入8到16之间的整数";
        this.$message({
          message: msg,
          type: "warning"
        });
        this.barcodeLength = "";
        return false;
      }
    },
    async batchSettingSpec(){
      if(!this.barcodeLength){
        this.$message({
          message: "请输入规格条码位数",
          type: "warning"
        });
        return false;
      }
      const { storeCode } = getLoginUser();
      const { result } = await this.$store.dispatch("genNewUniquesSuBarcode", {
        storeCode,
        genNum: this.ruleForm.skuModelList.length,
        barcodeLength: this.barcodeLength,
      })
      console.log("result:",result);
      this.ruleForm.skuModelList.forEach((v,i) => {
        result.forEach((o,index)=>{
          if(i===index && !v.specBarcode){
              v.specBarcode = o;
          }
        })
      });
      this.dialogVisibleBarcodeLength = false;
    },
    showBarcode(){
      this.dialogVisibleBarcodeLength = true;
    },
    addSpecModelsNew(row,i){
      this.currentSpecIndex = i;
      this.formSpec.specId = row.specId;
      this.formSpec.specValue = "";
      this.dialogVisibleSpecModels = true;
    },
    addSpecSubmit(formName){
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.formSpec));
          this.$store.dispatch("addSpecValue", params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              const raw = this.ruleForm.specificationList[this.currentSpecIndex];
              const newItem = {
                specValue: res.result.specValue,
                valueId: res.result.valueId
              };
              raw.specModels.push(newItem);
              if (raw._rawSpecModels) {
                raw._rawSpecModels = Object.freeze(raw._rawSpecModels.concat(newItem));
              } else {
                raw._rawSpecModels = Object.freeze(raw.specModels.slice());
              }
              this.currentSpecIndex = -1;
              this.dialogVisibleSpecModels = false;
            }
          });
        }
      })
    },
    filterGt(){
      this.formSpec.specValue = this.formSpec.specValue.replace(";", ""); //过滤0开头
      this.formSpec.specValue = this.formSpec.specValue.replace("；", ""); //过滤0开头
      this.formSpec.specValue = this.formSpec.specValue.replace(",", ""); //过滤0开头
      this.formSpec.specValue = this.formSpec.specValue.replace("，", ""); //过滤0开头
    },
  }
};
</script>
<style lang="scss">
.add-goods-container {
  .el-scrollbar__wrap {
    overflow-x: hidden;
  }
  .step-wrapper {
    border-bottom: 1px solid #ddd;
  }
  .btn {
    margin-left: 10px;
    .hmicon {
      font-size: 12px;
      margin-right: 5px;
    }
  }
}
</style>
<style lang="scss" scoped>
.title {
  color: #606266;
  font-weight: bold;
  font-size: 14px;
}

.table {
  margin-top: 20px;
  border: 1px solid #dcdfe6;
  border-radius: 5px;
  .table-control {
    padding: 0 29px;
    border-bottom: 1px solid #ddd;
  }
  .table-row:nth-child(odd) {
    background: #f7f7f7;
    color: #222;
  }
}

.brand-select {
  .el-input {
    width: 215px;
  }
  .el-tag {
    margin-right: 10px;
  }
}

.specification-list {
  li {
    padding: 7px 10px;
    margin: 0;
    color: #666;
    background-color: #f8f8f8;
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
    margin: 20px 0;
  }
  .spec-value-select {
    min-width: 120px;
    max-width: 220px;
    min-height: 32px;
    flex-wrap: wrap;
    background: #fff;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding: 4px 8px;
    .el-tag {
      margin-bottom: 4px;
    }
  }
}

.priview {
  position: relative;
  width: 250px;
  height: 206px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .video {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}

.table-row {
  padding: 5px 0;
}

.upload-upload-btn {
  .tips {
    color: #999;
    font-size: 12px;
    line-height: 20px;
  }

  .logo {
    width: 80px;
    height: 80px;
  }

  .btn {
    border: 1px solid #ddd;
    text-align: center;
    padding: 10px;
    margin-right: 10px;
    width: 80px;
    height: 80px;
    cursor: pointer;
    .add-wrapper {
      width: 30px;
      height: 30px;
      line-height: 30px;
      background: #e50065;
      color: #fff;
      text-align: center;
      border-radius: 50%;
      margin: 0 auto;
      span {
        font-size: 12px;
      }
      cursor: pointer;
      .hmicon {
        font-size: 14px;
        margin-right: 0 !important;
      }
    }
  }
}

.el-upload__tip {
  line-height: 30px;
}
.hmicon-shuru{
  font-size: 14px;
}
.barcodeTips{
  color: #e50065;
  line-height: 22px;
}
</style>
